export { type ImageOnlyProps, default as ImageOnly } from './ImageOnly';
